import { get } from './P3Api';

async function getItem(itemId) {
  return get(`items/${itemId}`);
}

async function getItemsByCriteria({
  category, group = null, method = null, certification = null, brand = null, misc = null, commodity = null, grade = null, variety = null, type = null,
}) {
  let criteria = `?size=5000&categoryId=${category}`;
  criteria += group === null ? '' : `&group=${group}`;
  criteria += method === null ? '' : `&method=${method}`;
  criteria += certification === null ? '' : `&certification=${certification}`;
  criteria += brand === null ? '' : `&brand=${brand}`;
  criteria += commodity === null ? '' : `&commodity=${commodity}`;
  criteria += misc === null ? '' : `&misc=${misc}`;
  criteria += grade === null ? '' : `&grade=${grade}`;
  criteria += variety === null ? '' : `&variety=${variety}`;
  criteria += type === null ? '' : `&type=${type}`;
  return get(`items/${criteria}`);
}

async function getItemsByItemCodes(itemIds, apiToken) {
  return get(`items/?itemCode=${itemIds}`, apiToken);
}

export { getItem, getItemsByCriteria, getItemsByItemCodes };
